module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow.blue-a96cad50cdead7ec7fff6b6dd7573bc0.svg";